import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

const CustomStoryParagraph = ({ className, ...props }: ComponentPropsWithoutRef<'p'>) => {
  return <p className={classNames('md:text-2xl font-light', className)} {...props} />;
};

export default CustomStoryParagraph;
